module.exports = __webpack_public_path__ + "static/media/ZHJ_ONLINE.d3796737.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/logos/ZHJ_ONLINE.png
// module id = 213
// module chunks = 0